"use client";
import { ark } from "../factory.js";
import { useProgressContext } from "./use-progress-context.js";
import { forwardRef } from "react";
import { mergeProps } from "@zag-js/react";
import { jsx } from "react/jsx-runtime";
//#region src/components/progress/progress-range.tsx
var ProgressRange = forwardRef((props, ref) => {
	const mergedProps = mergeProps(useProgressContext().getRangeProps(), props);
	return /* @__PURE__ */ jsx(ark.div, {
		...mergedProps,
		ref
	});
});
ProgressRange.displayName = "ProgressRange";
//#endregion
export { ProgressRange };
